import thumb from '../../../assets/images/address/thumb.png';
import full01 from '../../../assets/images/address/full01.png';
import full02 from '../../../assets/images/address/full02.png';
import full03 from '../../../assets/images/address/full03.png';
import full04 from '../../../assets/images/address/full04.png';

const ipAddressData = {
  name: 'IP Address Tracker',
  description:
    'A web app for finding places on the map and location details using IP Addresses.',
  skills: ['SCSS', 'React'],
  sources: [
    { caption: 'Default IP | IP Address Tracker', source: full01 },
    { caption: 'IP Search | IP Address Tracker', source: full02 },
    { caption: 'IP Search | IP Address Tracker', source: full03 },
    { caption: 'Address Details | IP Address Tracker', source: full04 },
  ],
  thumbnail: thumb,
  repoUrl: 'https://github.com/justsolomon/ip-address-tracker',
  liveUrl: 'https://ipaddress-tracker.netlify.app/',
};

export default ipAddressData;
